<!--Sección para Añadir-->
<div class="container-fluid crud-button">
 <div class="row crud-search" >
    <ngx-crud-title></ngx-crud-title>
    <span fxFlex></span>
    <ngx-crud-buttom-add></ngx-crud-buttom-add>
  </div>
</div>
<ng-content></ng-content>
   